/*
 * Die Präsentationen der Verwaltung.
 *
 * Der Inhalt steht bewusst im Code und nicht in der Datenbank: Jede
 * Präsentation hat ihre eigenen Folien (React), ihre Vertonung je Schritt und
 * ein PDF — das alles entsteht zusammen und ändert sich nur zusammen.
 *
 * NEUE PRÄSENTATION: Ordner neben `jaaPlatform2026` anlegen (script.js +
 * Slides.jsx), Aufnahmen und `manifest.json` nach
 * `public/praesentationen/<slug>/`, hier eintragen. Der Test
 * `presentations.test.js` prüft, dass jede Aufnahme da ist und ihr Text zum
 * Skript passt.
 */

import * as jaaPlatform2026 from './jaaPlatform2026/script'
import JaaPlatformSlides from './jaaPlatform2026/Slides'

export const PRESENTATIONS = [
	{
		slug: jaaPlatform2026.SLUG,
		title: 'The JA Austria Platform',
		subtitle: 'From master data to certificate — the Junior year on one platform',
		audience: 'JA organisations in Europe',
		language: 'English',
		minutes: 2,
		cover: `${jaaPlatform2026.AUDIO}/title.jpg`,
		createdAt: '2026-11-01',
		script: jaaPlatform2026,
		Slides: JaaPlatformSlides,
		// Die Stimmen sind zügig, aber nicht gehetzt: bei 1,1 läuft das Ganze knapp zwei Minuten.
		tempo: 1.1
	}
]

export const findPresentation = slug => PRESENTATIONS.find(p => p.slug === slug)
